import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const BlogPostFormPage = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {isEdit ? 'Edit Blog Post' : 'Create Blog Post'}
      </Typography>
      <Typography>Coming soon...</Typography>
    </Container>
  );
};

export default BlogPostFormPage;